import { CompanyLogo, HeaderLogo } from "../../../styles/component/style";
import { Images } from "../../../assets/images";
import {
  LogoContainer,
  LinksContainer,
  ProfileImage,
  LogoutText,
  BigScreen,
  SmallScreenMenu,
  SmallScreen,
  Row,
  H2,
  ImageContainer,
  LogoutIcon,
} from "./Styles";
import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import COLORS from "../../../assets/Colors";
import _ from "lodash";
import { navigate, useLocation } from "@reach/router";
import labels from "../../../helpers/labels.json";
import useAlert from "../../../hooks/useAlert";
import { scroller } from "react-scroll";
import { TranslaterContext } from "../../../providers/TranslaterProvider";
import DropDownMenu from "../../common/DropDownMenu";
import TemporaryDrawer from "./Drawer";
import useViewer from "../../../hooks/useViewer";
import AuthService from "../../../services/AuthService";
import moment from "moment";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";

const EXCLUDE_URL = ["create-profile"];

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    height: 74,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderBottom: "1px solid #e1e3ee",
  },
  appSpacedBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    height: 74,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxShadow: "none",
    borderBottom: "1px solid #e1e3ee",
    marginTop: 40,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
}));

export default function StyledAppBar({
  NavPages,
  hideLinks,
  LandingPage,
  ArbitPages,
  cartCount,
  setShowDrawer,
  stats,
  hideIcon,
  password,
  showDrawer,
}) {
  const { userObject, globalState, setGlobalState, setUserObject } =
    useViewer();
  const { showAlert, hideAlert } = useAlert();
  const { translaterOpen } = useContext(TranslaterContext);
  const location = useLocation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  async function viewerLogout(viewerId, role) {
    try {
      const payload = {
        logoutTime: moment(new Date()).format("HH:mm"),
        role: role,
      };
      const eventId = userObject?.eventId;
      const response = await AuthService.viewerLogout(viewerId, payload);
      if (response?.status) {
        enqueueSnackbar("Logout successfully", {
          variant: "success",
        });
        localStorage.removeItem("auth_token");
        localStorage.removeItem("role");
        localStorage.removeItem("pollArray");
        localStorage.removeItem("dsnl_cookies_enabled");
        navigate(`/events/gallery?eventId=${eventId}`);
        setGlobalState({ customTab: [] });
        setUserObject({});
        // setToken("logged_out");
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      hideAlert();
    }
  }

  const handleLogout = () => {
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      clickPrimaryBtn: () => {
        viewerLogout(userObject?.viewerId, "eventViewer");
      },
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });
  };

  return (
    <AppBar
      position="fixed"
      style={{
        boxShadow: "5px 5px 8px #00000011",
        backgroundColor: globalState?.theme?.themeHeader?.bannerBackgroundColor
          ? globalState?.theme?.themeHeader?.bannerBackgroundColor
          : COLORS.PRIMARY_WHITE,
      }}
      className={translaterOpen ? classes.appSpacedBar : classes.appBar}
    >
      <Toolbar className={classes.toolbar}>
        {password === true ? (
          <>
            <LogoContainer
              style={{
                justifyContent:
                  globalState?.theme?.themeHeader?.logoPlacement === "right"
                    ? "flex-start"
                    : "flex-end",
              }}
            >
              {globalState?.theme?.themeHeader?.logoImage ? (
                <HeaderLogo
                  src={
                    globalState?.theme?.themeHeader?.logoImage
                      ? globalState?.theme?.themeHeader?.logoImage
                      : Images.companyLogo
                  }
                  width={globalState?.theme?.themeHeader?.logoWidth}
                  height={globalState?.theme?.themeHeader?.logoHeight}
                />
              ) : null}
            </LogoContainer>
            <ImageContainer>
              {globalState?.theme?.themeHeader?.eventTitleImage ? (
                <CompanyLogo
                  src={globalState?.theme?.themeHeader?.eventTitleImage}
                />
              ) : (
                <H2
                  style={{
                    color: globalState?.theme?.themeHeader?.eventTitleColor,
                    textShadow: `2px 2px 4px ${globalState?.theme?.themeHeader?.eventTitleShadowColor}`,
                  }}
                >
                  {globalState?.eventTitle}
                </H2>
              )}
            </ImageContainer>
          </>
        ) : (
          <>
            <LogoContainer
              justifyContent={globalState?.theme?.themeHeader?.logoPlacement}
              style={{
                justifyContent:
                  globalState?.theme?.themeHeader?.logoPlacement === "right"
                    ? "flex-end"
                    : "flex-start",
              }}
            >
              {globalState?.theme?.themeHeader?.logoImage ? (
                <HeaderLogo
                  onClick={() =>
                    LandingPage
                      ? scroller.scrollTo("hero", {
                          duration: 500,
                          offset: -70,
                          smooth: true,
                        })
                      : _.isEmpty(userObject)
                      ? ""
                      : navigate("/gallery-viewer-live")
                  }
                  width={globalState?.theme?.themeHeader?.logoWidth}
                  height={globalState?.theme?.themeHeader?.logoHeight}
                  src={
                    globalState?.theme?.themeHeader?.logoImage
                      ? globalState?.theme?.themeHeader?.logoImage
                      : Images.companyLogo
                  }
                />
              ) : null}
            </LogoContainer>
            <ImageContainer>
              {globalState?.theme?.themeHeader?.eventTitleImage ? (
                <CompanyLogo
                  src={globalState?.theme?.themeHeader?.eventTitleImage}
                />
              ) : (
                <H2
                  style={{
                    color: globalState?.theme?.themeHeader?.eventTitleColor,
                    textShadow: `2px 2px 4px ${globalState?.theme?.themeHeader?.eventTitleShadowColor}`,
                  }}
                >
                  {globalState?.eventTitle}
                </H2>
              )}
            </ImageContainer>
          </>
        )}

        <BigScreen>
          {hideLinks ? null : (
            <LinksContainer>
              {_.isEmpty(userObject) ||
              EXCLUDE_URL.some((path) => location?.pathname?.includes(path)) ? (
                <>{NavPages ? <></> : <></>}</>
              ) : (
                <>
                  <H2>
                    <DropDownMenu
                      title="Tabs"
                      options={[
                        {
                          name: "Sign Out",
                          props: {
                            onClick: () => handleLogout(),
                          },
                        },
                      ]}
                    />
                  </H2>
                  {globalState?.general?.eventTemplate === "AGM" &&
                    globalState?.theme?.themeNavigationBar?.navBarTreatment ===
                      "alwaysVisible" &&
                    showDrawer && (
                      <Row onClick={handleLogout}>
                        <LogoutIcon
                          src={require("../../../assets/images/logout.svg")}
                        />
                        <LogoutText>{"Sign Out"}</LogoutText>
                      </Row>
                    )}
                </>
              )}
            </LinksContainer>
          )}
        </BigScreen>

        <SmallScreenMenu>
          {_.isEmpty(userObject) ? <> </> : null}
        </SmallScreenMenu>
        <SmallScreenMenu>
          {!_.isEmpty(userObject) ? (
            <>
              <TemporaryDrawer
                menuItems={[
                  {
                    name: "Sign Out",
                    props: {
                      onClick: () => handleLogout(),
                    },
                  },
                ]}
              />
            </>
          ) : (
            <SmallScreen>
              <Row>
                <LogoutText onClick={handleLogout}>
                  {labels["appbar.logout"]}
                </LogoutText>
                {password === true ? (
                  <ProfileImage
                    src={
                      userObject.avatarUrl
                        ? userObject.avatarUrl
                        : require("../../../assets/images/userPlaceholder.svg")
                    }
                    onClick={() => navigate("/gallery-viewer-live")}
                  />
                ) : null}
              </Row>
            </SmallScreen>
          )}
        </SmallScreenMenu>
      </Toolbar>
    </AppBar>
  );
}
